const columnDataGridConsignment = [
  // {
  //   dataField: 'pieceNumId',
  //   caption: 'Ключ УЕ',
  //   editorType: 'dxTextBox',
  //   groupItem: 1
  // },
  {
    dataField: 'qcId',
    caption: '№ СК',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'cgId',
    caption: '№ партии',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'actualPieceId',
    caption: '№ УЕ',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'thick',
    caption: 'Толщина, мм',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'width',
    caption: 'Ширина, мм',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'length',
    caption: 'Длина, мм',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'weightNetto',
    caption: 'Вес нетто, т',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'weightBrutto',
    caption: 'Вес брутто, т',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'weightRemain',
    caption: 'Остаточный вес',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'heatId',
    caption: '№ плавки',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'internalPieceId',
    caption: 'Внутренний номер УЕ',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'klPok',
    caption: 'Класс цинкового покрытия',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'cvet',
    caption: 'Цвет покрытия',
    editorType: 'dxTextBox',
    groupItem: 1
  },
  {
    dataField: 'customerName',
    caption: 'Грузополучатель рус.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'customerNameEng',
    caption: 'Грузополучатель анг.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoAddressSo',
    caption: 'Адрес получателя рус.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoAddressEnSo',
    caption: 'Адрес получателя англ.',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoStationNameSo',
    caption: 'Ст.назначения',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'shiptoStationCodeSo',
    caption: 'Код станции назначения',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'vehicleId',
    caption: '№ тс',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'dateOm',
    caption: 'Дата отгрузки Северсталь',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'deliveryId',
    caption: 'Номер поставки',
    editorType: 'dxTextBox',
    groupItem: 2
  },
  {
    dataField: 'l4SoId',
    caption: '№ СЗ сист.',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'soDescrId',
    caption: '№ Заказа',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'soLineDescrId',
    caption: 'Позиция заказа',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'zzordOtsortConf',
    caption: 'Признак ОХ из заказа',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'storageTimeCount',
    caption: 'Срок хранения',
    editorType: 'dxTextBox',
    groupItem: 3
  },
  {
    dataField: 'remainingTimeCount',
    caption: 'Осталось времени',
    editorType: 'dxTextBox',
    groupItem: 3
  }
];

export default columnDataGridConsignment;
